import { Action, ActionCreator } from 'redux';
import { ConfigInterface } from './config.interface';

export const CLEAR = 'CLEAR';
export interface ClearConfigAction extends Action {
    config;
}

export const clearConfig: ActionCreator<ClearConfigAction> =
    (config) => ({
        type: CLEAR,
        config: config
    });

export const UPDATEREGION = 'UPDATEREGION';
export interface UpdateRegionAction extends Action {
    config;
}

export const updateRegion: ActionCreator<UpdateRegionAction> =
    (config) => ({
        type: UPDATEREGION,
        config: config
    });

export const CHANGEGUESTLISTOPENSTATUS = 'CHANGEGUESTLISTOPENSTATUS';
export interface ChangeGuestListOpenStatusAction extends Action {
    status;
}

export const changeGuestListOpenStatus: ActionCreator<ChangeGuestListOpenStatusAction> =
    (status) => ({
        type: CHANGEGUESTLISTOPENSTATUS,
        status: status
    });

export const CHANGEVIPLISTOPENSTATUS = 'CHANGEVIPLISTOPENSTATUS';
export interface ChangeVipListOpenStatusAction extends Action {
    status;
}

export const changeVipListOpenStatus: ActionCreator<ChangeVipListOpenStatusAction> =
    (status) => ({
        type: CHANGEVIPLISTOPENSTATUS,
        status: status
    });

// export const ALLVIP = 'ALLVIP';
// export interface SetAllVipAction extends Action {
//     status;
// }

// export const setAllVipAction: ActionCreator<SetAllVipAction> =
//     (status) => ({
//         type: ALLVIP,
//         status: status
//     });
